import "./features.css";
import { useEffect, useState } from "react";
import { FaRegTrashAlt } from "react-icons/fa";
import { BiEditAlt } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { Modal, Button, message } from "antd";
import {
  addTermApi,
  updateTermApi,
  getLocalizedTermsApi,
} from "../../APIs/TermsApis";
import { modules } from "../../utils/ReactQuillConfig";

export const Features = () => {
  const [addNewTxtOpen, setAddNewTxtOpen] = useState(false);
  const [editTxtOpen, setEditTxtOpen] = useState(false);
  const [addTxt, setAddTxt] = useState("");
  const [addTxtEn, setAddTxtEn] = useState("");
  const [editTxt, setEditTxt] = useState("");
  const [editTxtEn, setEditTxtEn] = useState("");
  const [features, setFeatures] = useState({});
  const [refetch, setRefetch] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getFeatures();
  }, [refetch]);
  ///getFeatures func
  const getFeatures = async () => {
    try {
      const res = await getLocalizedTermsApi();

      setFeatures(res?.data?.data);
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("user");
        navigate("/login");
      }
      error
        ? error?.response?.data?.errors.map((error) =>
            message.error(error.message)
          )
        : message.error("Server Error Please Try Again Later !");
    }
  };

  const handleCreate = async () => {
    if (features) {
      const res = await updateTermApi(features?._id, {
        features: {
          en: addTxtEn,
          ar: addTxt,
        },
      });

      setFeatures(res?.data?.data);
      setLoading(false);
    }

    try {
      const res = await addTermApi({ features: { en: addTxtEn, ar: addTxt } });
      setFeatures(res?.data?.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      error
        ? error?.response?.data?.errors.map((error) =>
            message.error(error.message)
          )
        : message.error("Server Error Please Try Again Later !");
    }
  };

  const handleUpdate = async () => {
    try {
      const res = await updateTermApi(features._id, {
        features: {
          en: editTxtEn,
          ar: editTxt,
        },
      });
      setFeatures(res?.data?.data);
      setEditTxtOpen(false);
    } catch (error) {
      error
        ? error?.response?.data?.errors.map((error) =>
            message.error(error.message)
          )
        : message.error("Server Error Please Try Again Later !");
    }
  };

  return (
    <>
      <div className='features-main'>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <p className='features-top-txt'>
            <span style={{ color: "rgba(151, 151, 151, 1)" }}>
              لوحة التحكم /
            </span>{" "}
            <span>المميزات </span>
          </p>
          {!features && (
            <button
              className='features-add-features-btn'
              onClick={() => {
                setAddNewTxtOpen(true);
              }}
            >
              إضافة نص جديد
            </button>
          )}
        </div>
        <div className='features-content-div'>
          <div className='features-icons-div'>
            {features && (
              <span
                className='features-edit'
                onClick={() => {
                  setEditTxtOpen(true);
                  setEditTxt(features?.features?.ar);
                  setEditTxtEn(features?.features?.en);
                }}
              >
                <BiEditAlt style={{ fontSize: "20px" }} />
              </span>
            )}
            {/* <span
              className="features-delete"
              // onClick={() => deleteSectionFunc(cat?.id)}
            >
              <FaRegTrashAlt style={{ fontSize: "18px" }} />
            </span> */}
          </div>
          <h1 className='text-2xl'>العربية:</h1>
          <div
            className='rules-txt-div'
            dangerouslySetInnerHTML={{
              __html: features?.features?.ar ?? "لا يوجد نص لعرضه بعد",
            }}
          />
          <h1 className='text-2xl text-left mt-12'>:English</h1>
          <div
            className='rules-txt-div text-left'
            dangerouslySetInnerHTML={{
              __html: features?.features?.en ?? "No content to display yet",
            }}
          />
        </div>
      </div>
      {/***** add new text******/}
      <Modal
        className='features-add-features-modal'
        open={addNewTxtOpen}
        onOk={() => {}}
        onCancel={() => {
          setAddNewTxtOpen(false);
        }}
        footer={null}
      >
        <div className='features-add-features-modal-body'>
          <h1 className='text-2xl my-2'>العربية:</h1>
          <ReactQuill value={addTxt} onChange={setAddTxt} modules={modules} />
          <h1 className='text-2xl my-2'>:English</h1>
          <ReactQuill
            value={addTxtEn}
            onChange={setAddTxtEn}
            modules={modules}
            className='text-left'
          />
          <div className='features-edit-features-modal-btns'>
            <Button
              className='features-edit-features-modal-okBtn'
              onClick={handleCreate}
              loading={loading}
            >
              إضافة
            </Button>
            <Button
              className='features-edit-features-modal-cancelBtn'
              onClick={() => {
                setAddNewTxtOpen(false);
                setAddTxt("");
              }}
            >
              إلغاء
            </Button>
          </div>
        </div>
      </Modal>
      {/***** edit text******/}
      <Modal
        className='features-add-features-modal'
        open={editTxtOpen}
        onOk={() => {}}
        onCancel={() => {
          setEditTxtOpen(false);
        }}
        footer={null}
      >
        <div className='features-add-features-modal-body'>
          <h1 className='text-2xl my-2'>العربية:</h1>
          <ReactQuill value={editTxt} onChange={setEditTxt} modules={modules} />
          <h1 className='text-2xl my-2'>:English</h1>
          <ReactQuill
            value={editTxtEn}
            onChange={setEditTxtEn}
            modules={modules}
          />
          <div className='features-edit-features-modal-btns'>
            <Button
              className='features-edit-features-modal-okBtn'
              onClick={handleUpdate}
              //   loading={loading}
            >
              تعديل
            </Button>
            <Button
              className='features-edit-features-modal-cancelBtn'
              onClick={() => {
                setEditTxtOpen(false);
              }}
            >
              إلغاء
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};
